import React from 'react';

/** Page header used on every form page – Everee centred, Empivo on the right (as in the Word document). */
const EmpivoEvereeLogo = () => (
  <div className="grid grid-cols-[1fr_auto_1fr] items-center border-b border-gray-200 px-6 py-5 md:px-10">
    <span />
    <img src="/images/everee.png" alt="Everee" className="h-9 object-contain md:h-12" />
    <div className="flex justify-end">
      <img src="/images/empivo.png" alt="Empivo" className="h-7 object-contain md:h-9" />
    </div>
  </div>
);

export default EmpivoEvereeLogo;
